<template>
    <div class="">

        <div class="row no-gutters py-2 mb-3 border-bottom ml-3">
          <div class="col-md-10 col-sm-12" >
              <h4 class="atlhr-dashboard-title mt-10">PF Advance Application Approve List<span><a v-bind:href="pageurl">Dashboard</a> / PF Advance Application Approve List</span></h4>
          </div>
         </div>
        <b-overlay :show="showoverlay_list" rounded="sm">
                  

            <div v-if="loans.length>0">
                    <common-list :pageurl="this.$api_url" :checkbox="checkbox"  :is_action="is_action" :appended_column="appended_column" is_pf="1" :key="list_key" :company_options="company_options" :employees="loans" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list> 
            </div>
            <div v-else>
                <div v-if="show_loader" class="list-no-data">
                    <span class="d-block text-center">Looking for relevant data..</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="list-no-data">
                    Looks like there is no PF advance application to show.
                </div>
            </div>
        </b-overlay>


        <b-modal id="delete-modal" title="Are you sure you want to delete this Advance ?" hide-footer> 
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="deleteLoan(loan_entity_id)">Delete <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <b-modal id="delete-payrun-modal" :title="payrun_delete_msg" hide-footer>Please enter your password to continue:
            <br />
            <input id="approvepass" type="password" class="form-control" v-model="approvepass" name="approvepass"> 

            <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert" style="clear: both; margin-top: 10px;"> {{incorrectpass}} </div>
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="deleteLoan(loan_entity_id)">{{btn_name}} <span v-if="loading != ''"><img :src="$api_url+'/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-payrun-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        
        </b-modal>


        <b-modal id="decline-modal" title="Are you sure you want to decline this Advance ?" hide-footer> 
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="pauseLoan(loan_entity_id)">Decline <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('decline-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>
        <b-modal id="unapprove-modal" title="Are you sure you want to unapprove this Advance ?" hide-footer> 
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="pauseLoan(loan_entity_id)">Unapprove <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('unapprove-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>
        <b-modal id="bv-modal-loan" size="lg" hide-footer v-bind:title="modal_title">
            <!-- <pf-loan-form :pageurl="this.$api_url" :flg="flg" :employee_id="0" :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom" :is_status="is_status" v-on:childToParent="getLoanData"></pf-loan-form>        -->          
            <pf-loan-form-front-new :pageurl="this.$api_url" :flg="flg" :employee_id="employee_id"  :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom" :is_status="is_status" v-on:childToParent="getLoanData"></pf-loan-form-front-new>
        
        </b-modal>
        <b-modal id="bv-modal-pf-loan-transactions-wizard" size="lg" hide-footer v-bind:title="modal_title">
            <pf-loan-transactions-wizard :pageurl="this.$api_url" :employee_id="employee_id" :key="tx_popup_count" :loan_id="loan_id" ></pf-loan-transactions-wizard>                  
        </b-modal>
        
        <b-modal id="installment-modal" title="Installment Breakdown" hide-footer> 
        <div class="row table-head">
            <div class="col-sm-4 font-weight-bold py-2">
                Installment No.
            </div>                      
            <div class="col-sm-4 font-weight-bold py-2">
                Month
            </div>
            <div class="col-sm-4 font-weight-bold py-2">
                Amount
            </div>
        </div>
  
        <div class="row table-row hover-bg"  v-for="(row, index) in my_installments" :key="index">
            <div class="col-sm-4 py-2 align-items-center d-flex">                    
                <div :style="(row.status==3) ? styleA : styleB" ><template v-if="(row.installment_type==0)">Installment #{{index+1}}</template><template v-else>Service Charge Installment</template></div>
            </div>
            <div class="col-sm-4 py-2 align-items-center d-flex" v-bind:style="[(row.status==3) ? {styleA} : {styleB}]">                    
                <div :style="(row.status==3) ? styleA : styleB">{{row.month}}</div>
            </div> 
            <div class="col-sm-4 py-2 align-items-center d-flex" v-bind:style="[(row.status==3) ? {styleA} : {styleB}]">
                <div :style="(row.status==3) ? styleA : styleB">{{formatMoney(row.amount)}}</div>
            </div>
        </div>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('installment-modal')">Close</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

    </div>
</template>


<script>
    export default{
        
        mounted() {
            
        },
        props: ['pageurl', 'flg'],
        data(){            
            
            return {
                
                loans:[], 
                loan_id:'',
                employee_id:'',
                tx_popup_count:0,
                styleA: 'color:#55ce63 !important',
                styleB: 'color:#009efb !important',
                my_installments:[],
                is_custom:'',
                is_status:'',             
                bank_names: [
                    { value: null, text: "--Select--" },
                ],  
                modal_title:'',
                count:'', 
                loan_stat_title: ["Declined","Applied","Approved","Pause/Stopped","Returned"],
                default_tenure: [0,150,0],
                showoverlay_list : false,                          
                successmsg:'',
                errormsg:[],
                selected_bank_id:0,
                loading:'',
                showoverlaymodal : false,
                show_loader:true,
                loan_entity_id:'',
                loan_update_status:'',
                loan_status:[
                    { value: null, text: "Select..." },
                    { value: "0", text: "Declined" },
                    { value: "1", text: "Applied" },
                    { value: "2", text: "Approved" },
                    { value: "3", text: "Pause/Stopped" },
                    { value: "4", text: "Returned" },
                ],
                 /**Child Component property data */
                is_action:1,
                checkbox:0, 
                list_key:0,
                loans:[],   
                default_column:['name','employee_code'],
                appended_column:[
                    { value: "company_loan_id", text: "Advance ID",type: "text"},
                    // { value: "loan_amount", text: "Amount",type: "number"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "loan_amount", text: "Amount",type: "amount"}, // Rejwan: 23-04-2025 2 decimal
                
                    { value: "deduction_start_month", text: "Deduction Start Month",type: "monthyear"},
                    { value: "loan_status", text: "Status",type: "text"},
                ],
                primary_key:'id', 
                company_options:[],
                tmp_loans:[],
                approver_settings:[],
                /***Child Component property data */

                approvepass: '',
                incorrectpass: '',
                payrun_delete_msg:'',
                btn_name:'',
                loading:'',
            }
        },
        methods:{
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // },  
            toMoney: function(amount){
                if(amount !="0")
                {
                    if(!isNaN(amount))
                    {
                        var number = Number(amount);
                        return number;
                    }
                var NumWithoutCommas = amount.replace(/,/g, ''); 
                var number = Number(NumWithoutCommas).toFixed(2);
                return number;
                }else
                    return amount;
            },
            
            showDeclineModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.loan_update_status = 0;
            this.$bvModal.show('decline-modal');
            this.approvepass=''; 
            },

            showUnapproveModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.loan_update_status = 1;
            this.$bvModal.show('unapprove-modal');
            this.approvepass=''; 
            },
            showDeleteModal: function(pageflg)
            {
                this.approvepass= '';
                this.incorrectpass= '';
                this.payrun_delete_msg='Are you sure to Delete this loan';
                this.btn_name='Delete';
                this.loan_entity_id=pageflg;
                this.$bvModal.show('delete-payrun-modal');
                this.approvepass=''; 
            },
            showLoanTransactions: function(loan_id,employee_id)
            { 
                this.loan_id = loan_id;
                this.employee_id = employee_id;
                this.tx_popup_count = this.tx_popup_count + 1;
                this.$bvModal.show('bv-modal-pf-loan-transactions-wizard');
            },
            showInstallment: function(loan)
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                let formData = new FormData();
                formData.append('loan_id', loan);        
                this.my_installments = [];
                this.showoverlay = true;
                axios.post(this.$api_url+'/pf/loan/installments', formData)
                .then(function (response) 
                {
                    this.my_installments = response.data;
                    this.showoverlay = false;
                    this.$bvModal.show('installment-modal');
                        
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            pauseLoan: function(pageflg)
            {
                
                this.loading='load'; 
                var update_status = this.loan_update_status;
                let formData = new FormData();
                formData.append('loan_id', pageflg); 
                formData.append('status', update_status); 
                axios.post(this.$api_url+'/pf/loan/update-status', formData) 
                    .then(function (response) 
                    {    
                        this.$bvModal.hide('pause-modal'); 
                        this.$bvModal.hide('approve-modal');  
                        this.$bvModal.hide('decline-modal'); 
                        this.$bvModal.hide('unapprove-modal'); 
                        
                        this.loan_entity_id=''; 
                        this.loan_update_status = '';
                        this.loading='';   
                        this.getLoanData();
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
                            
            },
            deleteLoan: function(pageflg)
            {
                
                this.loading='load'; 
                let formData = new FormData();
                formData.append('loan_id', pageflg); 
                if(this.approvepass!='')
                 {
                     var pass=this.approvepass;  
    			     this.loading='load';
                     formData.append('pass',pass);
                 }
                axios.post(this.$api_url+'/pf/loan/delete', formData) 
                    .then(function (response) 
                    {    

                   
                        if(response.data.success==true){
                            this.$bvToast.toast(response.data.message, {
                                title: `Success !`,
                                variant: 'success',
                                solid: true
                            });
                        }else{
                            this.$bvToast.toast(response.data.message, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                        this.$bvModal.hide('pause-modal'); 
                        this.$bvModal.hide('approve-modal');  
                        this.$bvModal.hide('decline-modal'); 
                        this.$bvModal.hide('unapprove-modal'); 
                        this.$bvModal.hide('delete-modal'); 
                        this.$bvModal.hide('delete-payrun-modal');
                        
                        this.loan_entity_id=''; 
                        this.loan_update_status = '';
                        this.loading='';   
                        this.getLoanData();
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        console.log(error);
                    });
                            
            },
            listReturn:function(data)
            {
                if(data.selected.length > 0)
                {
                    this.selected = data.selected;
                }
                else
                {
                    this.selected = [];
                    if(data.id > 0)
                    {

                        if(data.action_id == 0)
                        {
                            //this.showEmployeeDetails(data.id);
                        }
                        else if(data.action_id == 1)
                        {
                             this.editLoanInfo(data.id,0,0);
                        }
                        else if(data.action_id == 2)
                        {
                            this.editLoanInfo(data.id,1,0);
                        }
                        else if(data.action_id == 3)
                        {
                            this.showDeclineModal(data.id);
                        }
                        else if(data.action_id == 4)
                        {
                            this.editLoanInfo(data.id,0,3);
                        }
                        else if(data.action_id == 5)
                        {
                            this.editLoanInfo(data.id,0,2);
                        }
                        else if(data.action_id == 6)
                        {
                            this.showInstallment(data.id);
                        }
                        else if(data.action_id == 7)
                        {
                            this.editLoanInfo(data.id,0,1);
                        }
                        else if(data.action_id == 8)
                        {
                            this.showLoanTransactions(data.id);
                        }
                        else if(data.action_id == 9)
                        {
                            this.showDeleteModal(data.id);
                        }
                    }

                }
            },
            getLoanData: function()
            {
                this.loan_title = 'PF Application Lists';
                if(!this.checkNet()) return false;
                let currentObj = this; 
                currentObj.show_loader = true;
                
                axios.get(this.$api_url+'/pf/loan/applications' , {
                    params: {
                    }
                }).then(function(response){
                     this.tmp_loans = response.data.employee_data;
                    this.company_options = response.data.options;
                    
                    if(this.tmp_loans.length > 0 )
                    {
                        this.tmp_loans.forEach(element => {
                                if(element.id > 0)
                                {
                                    let depth = parseInt(this.approver_settings.depth);
                                    element.loan_amount = this.formatMoney(element.loan_amount);
                                    let dop = []; 
                                    if(this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Pause/Stopped'|| this.loan_stat_title[element.status] == 'Declined')
                                    {
                                        if(depth == 0)
                                        {
                                            dop = dop.concat([{ label: 'Approve' , value: 5 }]);
                                        }
                                    }
                                    if(element.has_tx==0  && (this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Declined'))
                                    {
                                        if(depth == 0)
                                        {
                                            dop = dop.concat([{ label: 'Unapprove' , value: 7 }]);
                                        }
                                    }
                                    if(element.has_tx==0  &&  (this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved'))
                                    {
                                        if(depth == 0)
                                        {
                                            dop = dop.concat([{ label: 'Decline' , value: 3 }]);
                                        }
                                        
                                    }
                                    if(element.has_tx==0  && (this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Declined' || this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Pause/Stopped'))
                                    {
                                        dop = dop.concat([{ label: 'Delete' , value: 9 }]);
                                    }
                                    if(this.loan_stat_title[element.status] == 'Approved')
                                    {
                                        dop = dop.concat([{ label: 'Pause / Stop' , value: 4 }]);
                                    }
                                    
                                    if(this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Pause/Stopped'|| this.loan_stat_title[element.status] == 'Declined')
                                    {
                                        dop = dop.concat([{ label: 'Edit' , value: 1 }]);
                                    }
                                    if(this.loan_stat_title[element.status] == 'Approved')
                                    {
                                        dop = dop.concat([{ label: 'Manual Payment' , value: 2 }]);
                                    }
                                    if(this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved'  ||  this.loan_stat_title[element.status] == 'Pause/Stopped')
                                    {
                                        dop = dop.concat([{ label: 'Installments' , value: 6 }]);
                                    }
                                    
                                    
                                    dop = dop.concat([{ label: 'Transactions' , value: 8 }]);

                                    element.actions = dop;
                                }
                            });
                        
                    }
                    this.$bvModal.hide('bv-modal-loan');
                    this.loans = this.tmp_loans;
                    this.list_key = this.list_key + 1;
                    
                    currentObj.show_loader = false;
                }.bind(this)).catch(function (error){ 

                    currentObj.show_loader = false;
                    currentObj.serverError(error);
                    
                    });

            },
            updateTransactions()
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/pf/loan/updatetransactions', {
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.$bvModal.hide('bv-modal-loan');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                
            },
            editLoanInfo(loan_id,is_custom,is_status)
            {
                this.modal_title = "PF Advance Application";
                this.is_custom = is_custom;
                this.loan_id = loan_id;
                this.is_status = is_status;
                this.count = this.count + 1;
                this.$bvModal.show('bv-modal-loan');
            }, 
            getApprovalSettings()
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/approver/company-settings', {
                    params: {
                        module: 7
                    }
                }).then(function(response){
                    this.approver_settings = response.data;
                    this.getLoanData();
               
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            }
        },
        created: function(){
           
            this.getApprovalSettings();

            //this.updateTransactions();
        }
    }
</script>

